var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main print-no-padding"},[_vm._m(0),_c('breadcrumb',{attrs:{"firstName":"门店管理"}}),_c('shop-content',{ref:"shopContent",attrs:{"type":2,"active-tab":_vm.$route.query.activeTab}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h2',{staticClass:"is-print-hide title-area"},[_c('span',{staticClass:"main-title"},[_vm._v("查看门店")])])
}]

export { render, staticRenderFns }